var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"alert alert-info"},[_c('strong',[_vm._v("Note: ")]),_vm._t("default",null,{"default":""})],2)}
var staticRenderFns = []

export { render, staticRenderFns }